(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shamtam-return-request"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-rr]');
  if (!root) return;
  var T = {};
  try { T = JSON.parse(root.querySelector('[data-rr-i18n]').textContent); } catch (e) {}
  var t = function (k, v) { var s = T[k] || k; if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); }); return s; };
  var $ = function (s) { return root.querySelector(s); };
  var api = root.dataset.endpoint.replace(/\/$/, '');
  var lang = (root.dataset.lang || 'en').toLowerCase().split('-')[0];
  // Dates and prices in the page language; English is British (21 October 2026, not October 21).
  var loc = lang === 'en' ? 'en-GB' : lang === 'pt' ? 'pt-PT' : lang === 'no' ? 'nb-NO' : lang;
  var sitekey = root.dataset.sitekey;
  var form = $('[data-rr-form]');
  // "Chat with us": Shopify Inbox opens with show(); no widget → the contact page.
  root.querySelectorAll('[data-sh-open-chat]').forEach(function (b) { b.addEventListener('click', function () {
    var inbox = document.querySelector('shopify-chat');
    if (inbox && typeof inbox.show === 'function') { inbox.show(); return; }
    window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/contact';
  }); });
  var state = { ticket: null, lines: [], photos: [], tsToken: null, tsId: null, busy: false };
  var MAX_PHOTOS = 6, MIN_PHOTOS = 2, MAX_BYTES = 15 * 1024 * 1024;

  // Turnstile, loaded only when this page has a site key. Managed mode is usually invisible.
  if (sitekey) {
    window.rrTurnstileReady = function () {
      state.tsId = window.turnstile.render($('[data-ts]'), { sitekey: sitekey, language: lang, appearance: 'interaction-only',
        callback: function (tok) { state.tsToken = tok; }, 'expired-callback': function () { state.tsToken = null; } });
    };
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=rrTurnstileReady&render=explicit';
    s.async = true; document.head.appendChild(s);
  }

  function msg(el, text, warn) { el.textContent = text || ''; el.hidden = !text; el.classList.toggle('is-warn', !!warn); }
  function err(code, text) {
    var el = root.querySelector('[data-err="' + code + '"]');
    if (el) { el.textContent = text || ''; el.hidden = !text; }
  }
  function dateText(iso) {
    try { return new Intl.DateTimeFormat(loc, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(iso)); } catch (e) { return iso.slice(0, 10); }
  }
  function money(u) {
    if (!u) return '';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: u.currency }).format(u.amount); } catch (e) { return u.amount + ' ' + u.currency; }
  }
  function errorText(code, j) {
    var map = { notfound: 'rr.err_notfound', notshipped: 'rr.err_notshipped', rate: 'rr.err_rate', check: 'rr.err_check', expired: 'rr.err_expired', open: 'rr.err_open' };
    return t(map[code] || 'rr.err_generic', { id: (j && j.id) || '' });
  }

  // ── step 1: find the order ──
  var findBtn = $('[data-find]');
  findBtn.addEventListener('click', lookup);
  ['#rr-order', '#rr-email'].forEach(function (s) { $(s).addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); lookup(); } }); });
  function lookup() {
    var order = $('#rr-order').value.trim(), email = $('#rr-email').value.trim();
    var lm = $('[data-lookup-msg]');
    $('#rr-order').setAttribute('aria-invalid', String(!order)); $('#rr-email').setAttribute('aria-invalid', String(!/@/.test(email)));
    if (!order || !/@/.test(email)) { msg(lm, t('rr.err_notfound')); return; }
    if (sitekey && !state.tsToken) { msg(lm, t('rr.err_check')); return; }
    findBtn.disabled = true; findBtn.textContent = t('rr.finding'); msg(lm, '');
    fetch(api + '/returns/lookup', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ order: order, email: email, turnstile: state.tsToken, lang: lang }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j.ok) { msg(lm, errorText(res.j.error, res.j)); resetTs(); return; }
        state.ticket = res.j.ticket; state.lines = res.j.lines || [];
        $('[data-found-text]').textContent = res.j.deliveredAt ? t('rr.found', { order: res.j.order, date: dateText(res.j.deliveredAt) }) : t('rr.found_sent', { order: res.j.order, date: dateText(res.j.sentAt) });
        $('[data-found]').hidden = false; $('[data-lookup-fields]').hidden = true; $('[data-lookup-actions]').hidden = true; $('[data-ts]').hidden = true;
        if (res.j.late) msg(lm, t('rr.warn_late'), true);
        root.querySelector('[data-step="1"]').classList.add('is-done');
        renderItems(); $('[data-rest]').hidden = false;
      })
      .catch(function () { msg(lm, t('rr.err_generic')); })
      .then(function () { findBtn.disabled = false; findBtn.textContent = t('rr.find_btn'); });
  }
  function resetTs() { if (state.tsId != null && window.turnstile) { try { window.turnstile.reset(state.tsId); } catch (e) {} state.tsToken = null; } }
  $('[data-change]').addEventListener('click', function () {
    state.ticket = null; $('[data-rest]').hidden = true; $('[data-found]').hidden = true; $('[data-lookup-fields]').hidden = false; $('[data-lookup-actions]').hidden = false; $('[data-ts]').hidden = false;
    msg($('[data-lookup-msg]'), ''); root.querySelector('[data-step="1"]').classList.remove('is-done'); resetTs(); $('#rr-order').focus();
  });

  // ── step 2: items ──
  function renderItems() {
    var box = $('[data-items]'); box.textContent = '';
    state.lines.forEach(function (l) {
      var row = document.createElement('div'); row.className = 'rr__item'; row.dataset.id = l.id;
      var cb = document.createElement('input'); cb.type = 'checkbox'; cb.id = 'rr-line-' + l.id;
      var img = l.image ? document.createElement('img') : document.createElement('span');
      if (l.image) { img.src = l.image; img.alt = ''; img.loading = 'lazy'; } else img.className = 'rr__ph';
      var name = document.createElement('label'); name.htmlFor = cb.id;
      name.textContent = l.title + (l.variant ? ' (' + l.variant + ')' : '');
      var sm = document.createElement('small'); sm.textContent = [money(l.unit), t('rr.bought', { n: l.qty })].filter(Boolean).join(' · '); name.appendChild(sm);
      var qty = document.createElement('div'); qty.className = 'rr__qty';
      var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', t('rr.qty_less'));
      var out = document.createElement('output'); out.textContent = '1';
      var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', t('rr.qty_more'));
      qty.append(minus, out, plus);
      qty.hidden = l.qty < 2;
      minus.addEventListener('click', function () { out.textContent = String(Math.max(1, +out.textContent - 1)); });
      plus.addEventListener('click', function () { out.textContent = String(Math.min(l.qty, +out.textContent + 1)); cb.checked = true; row.classList.add('is-on'); });
      cb.addEventListener('change', function () { row.classList.toggle('is-on', cb.checked); if (cb.checked) err('items', ''); });
      row.append(cb, img, name, qty); box.appendChild(row);
    });
    if (state.lines.length === 1) { var only = box.querySelector('input'); only.checked = true; only.closest('.rr__item').classList.add('is-on'); }
  }

  // ── step 4: resolution ──
  root.querySelectorAll('input[name=resolution]').forEach(function (r) {
    r.addEventListener('change', function () { $('[data-exchange]').hidden = r.value !== 'exchange' || !r.checked; err('res', ''); });
  });
  ['#rr-reason', '#rr-cond', '#rr-text'].forEach(function (s) { $(s).addEventListener('input', function () { $(s).removeAttribute('aria-invalid'); err({ '#rr-reason': 'reason', '#rr-cond': 'cond', '#rr-text': 'text' }[s], ''); }); });

  // ── step 5: photos ──
  var input = $('#rr-files'), drop = $('[data-drop]');
  input.addEventListener('change', function () { addFiles(input.files); input.value = ''; });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files); });
  function isHeic(f) { return /heic|heif/i.test(f.type) || /\.(heic|heif)$/i.test(f.name || ''); }
  // Re-encode to a JPEG of at most 1600 px: smaller uploads, no location data, readable in Telegram. A photo the
  // browser cannot decode (HEIC outside Safari) is sent as it is.
  function shrink(f) {
    if (!window.createImageBitmap) return Promise.resolve(f);
    return createImageBitmap(f).then(function (bmp) {
      var k = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
      var c = document.createElement('canvas'); c.width = Math.round(bmp.width * k); c.height = Math.round(bmp.height * k);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      return new Promise(function (res) { c.toBlob(function (b) { res(b ? new File([b], (f.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : f); }, 'image/jpeg', 0.85); });
    }).catch(function () { return f; });
  }
  function addFiles(list) {
    var files = Array.prototype.slice.call(list || []);
    var jobs = [];
    files.forEach(function (f) {
      if (state.photos.length + jobs.length >= MAX_PHOTOS) return;
      if (!/^image\//.test(f.type) && !isHeic(f)) { err('photos', t('rr.err_photo_type')); return; }
      jobs.push(shrink(f));
    });
    Promise.all(jobs).then(function (done) {
      done.forEach(function (f) {
        if (f.size > MAX_BYTES) { err('photos', t('rr.err_photo_big')); return; }
        if (!/^image\/(jpeg|png|webp|heic|heif)$/.test(f.type)) {
          if (isHeic(f)) f = new File([f], f.name, { type: 'image/heic' }); else { err('photos', t('rr.err_photo_type')); return; }
        }
        state.photos.push(f);
      });
      drawPhotos();
    });
  }
  function drawPhotos() {
    root.querySelectorAll('.rr__thumb').forEach(function (n) { if (n.dataset.url) URL.revokeObjectURL(n.dataset.url); n.remove(); });
    state.photos.forEach(function (f, i) {
      var d = document.createElement('div'); d.className = 'rr__thumb';
      if (/jpeg|png|webp/.test(f.type)) { var url = URL.createObjectURL(f); d.dataset.url = url; var im = document.createElement('img'); im.src = url; im.alt = ''; d.appendChild(im); }
      else { var fl = document.createElement('span'); fl.className = 'rr__file'; fl.textContent = f.name; d.appendChild(fl); }
      var x = document.createElement('button'); x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', t('rr.photo_remove'));
      x.addEventListener('click', function () { state.photos.splice(i, 1); drawPhotos(); });
      d.appendChild(x); drop.parentNode.insertBefore(d, drop);
    });
    drop.hidden = state.photos.length >= MAX_PHOTOS;
    $('[data-count]').textContent = state.photos.length ? t('rr.photos_n', { n: state.photos.length }) : '';
    if (state.photos.length >= MIN_PHOTOS) err('photos', '');
  }

  // ── step 6: send ──
  function collect() {
    var items = [];
    root.querySelectorAll('.rr__item').forEach(function (row) {
      if (row.querySelector('input[type=checkbox]').checked) items.push({ lineId: row.dataset.id, qty: +row.querySelector('output').textContent });
    });
    var res = root.querySelector('input[name=resolution]:checked');
    return { items: items, reason: $('#rr-reason').value, condition: $('#rr-cond').value, text: $('#rr-text').value.trim(),
      resolution: res ? res.value : '', exchangeWish: $('#rr-exchange').value.trim(), consent: $('#rr-consent').checked, lang: lang };
  }
  function check(p) {
    var bad = [];
    if (!p.items.length) { err('items', t('rr.err_items')); bad.push('[data-items]'); }
    if (!p.reason) { err('reason', t('rr.err_reason')); $('#rr-reason').setAttribute('aria-invalid', 'true'); bad.push('#rr-reason'); }
    if (!p.condition) { err('cond', t('rr.err_cond')); $('#rr-cond').setAttribute('aria-invalid', 'true'); bad.push('#rr-cond'); }
    if (p.text.length < 3) { err('text', t('rr.err_text')); $('#rr-text').setAttribute('aria-invalid', 'true'); bad.push('#rr-text'); }
    if (!p.resolution) { err('res', t('rr.err_res')); bad.push('.rr__res'); }
    if (state.photos.length < MIN_PHOTOS) { err('photos', t('rr.photos_need')); bad.push('[data-drop]'); }
    if (!p.consent) { err('consent', t('rr.err_consent')); bad.push('#rr-consent'); }
    return bad;
  }
  var FIELD_ERR = { items: 'rr.err_items', reason: 'rr.err_reason', cond: 'rr.err_cond', text: 'rr.err_text', res: 'rr.err_res', photos: 'rr.photos_need', photo_type: 'rr.err_photo_type', consent: 'rr.err_consent' };
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.busy || !state.ticket) return;
    var p = collect(), sm = $('[data-send-msg]'), btn = $('[data-send]');
    var bad = check(p);
    if (bad.length) { msg(sm, t('rr.err_fix')); var first = root.querySelector(bad[0]); if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    msg(sm, ''); state.busy = true; btn.disabled = true; btn.textContent = t('rr.sending');
    var fd = new FormData(); fd.append('ticket', state.ticket); fd.append('payload', JSON.stringify(p));
    state.photos.forEach(function (f, i) { fd.append('photos', f, f.name || ('photo-' + (i + 1) + '.jpg')); });
    fetch(api + '/returns/submit', { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j.ok) {
          form.hidden = true; var done = $('[data-done]'); $('[data-done-p1]').textContent = t('rr.done_p1', { id: res.j.id }); done.hidden = false; done.focus();
          done.scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
        }
        if (res.j.error === 'invalid' && res.j.fields) { res.j.fields.forEach(function (f) { err(f === 'photo_type' ? 'photos' : f, t(FIELD_ERR[f] || 'rr.err_fix')); }); msg(sm, t('rr.err_fix')); return; }
        msg(sm, errorText(res.j.error, res.j));
      })
      .catch(function () { msg(sm, t('rr.err_generic')); })
      .then(function () { state.busy = false; btn.disabled = false; btn.textContent = t('rr.send_btn'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shamtam-returns-page-chat"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-returns-page]');
    if (!root) return;
    // The live chat is Shopify Inbox; <shopify-chat> opens with show(). No widget → the contact page.
    const openChat = () => {
      const inbox = document.querySelector('shopify-chat');
      if (inbox && typeof inbox.show === 'function') { inbox.show(); return; }
      window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/contact';
    };
    root.querySelectorAll('[data-sh-open-chat]').forEach((b) => b.addEventListener('click', openChat));
    // Phones: the "Start a return" bar sticks to the bottom once the top button has scrolled away, and leaves
    // again when the bottom banner (which has its own button) comes into view.
    const sticky = root.querySelector('[data-rp-sticky]');
    const top = root.querySelector('[data-rp-main-cta]');
    const band = root.querySelector('.rp__band');
    if (!sticky || !top || !('IntersectionObserver' in window)) return;
    let topOut = false, bandIn = false;
    const sync = () => { sticky.hidden = !(topOut && !bandIn); };
    new IntersectionObserver(([e]) => { topOut = !e.isIntersecting && e.boundingClientRect.top < 0; sync(); }).observe(top);
    new IntersectionObserver(([e]) => { bandIn = e.isIntersecting; sync(); }).observe(band);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shamtam-returns-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-returns-page]');
    if (!root) return;
    const answer = root.querySelector('[data-return-answer]');
    // The live chat is Shopify Inbox; Tidio was removed and these buttons did nothing (audit 2026-09-25 SS-02).
    // <shopify-chat> opens with show() (`open` is only a state flag). No widget → the contact page.
    const openChat = () => {
      const inbox = document.querySelector('shopify-chat');
      if (inbox && typeof inbox.show === 'function') { inbox.show(); return; }
      window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/contact';
    };
    const content = {
      changed: { label: 'For a change of mind', title: 'You have 30 calendar days from delivery to make your request.', body: 'Once your request is accepted, return the item unused, in its original condition and packaging. You arrange and pay for the return postage; please use a tracked service and keep the receipt.', steps: ['Request in your SHAMTAM account', 'We respond within 2 business days', 'Send it within 14 calendar days of approval'] },
      issue: { label: 'For a damaged, faulty or incorrect item', title: 'Tell us what happened, and we’ll make it right.', body: 'Start the request from your order and add clear photos if asked. If the item is damaged, faulty or incorrect, SHAMTAM will arrange the appropriate resolution and cover reasonable return costs.', steps: ['Choose the relevant reason in your account', 'Share photos if requested', 'Wait for your tailored instructions before sending'] },
      hygiene: { label: 'For personal or sealed items', title: 'Eligibility depends on whether the item is still sealed and suitable for return.', body: 'For hygiene and safety, opened personal-care products, personalised goods, and sealed goods that are unsuitable for return once unsealed may not be eligible. Your account shows the available route for each item.', steps: ['Check eligibility from the original order', 'Keep seals and packaging intact', 'Ask us before opening if you are unsure'] }
    };
    root.querySelectorAll('[data-return-tab]').forEach(button => button.addEventListener('click', () => {
      const next = content[button.dataset.returnTab];
      root.querySelectorAll('[data-return-tab]').forEach(tab => tab.setAttribute('aria-selected', String(tab === button)));
      answer.innerHTML = `<p class="sh-return-guide__answer-label">${next.label}</p><h3>${next.title}</h3><p>${next.body}</p><ul>${next.steps.map(step => `<li>${step}</li>`).join('')}</ul>`;
    }));
    root.querySelectorAll('[data-sh-open-chat]').forEach(button => button.addEventListener('click', openChat));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shamtam-shipping-page-chat"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-shipping-journey]');
    if (!root) return;
    const dataNode = root.querySelector('[data-shipping-thresholds]');
    let thresholds = {};
    try { thresholds = JSON.parse(dataNode.textContent); } catch (_) { return; }
    const country = root.querySelector('[data-country]');
    const marketForm = document.getElementById('sh-shipping-market-form');
    const postcode = root.querySelector('[data-postcode]');
    const button = root.querySelector('[data-calculate]');
    const summary = root.querySelector('[data-threshold-summary]');
    const ratesBox = root.querySelector('[data-rates]');
    const countryFlag = root.querySelector('[data-country-flag]');
    const dutyNote = root.querySelector('[data-duty-note]');
    const dutyTitle = root.querySelector('[data-duty-title]');
    const dutyCopy = root.querySelector('[data-duty-copy]');
    // Page copy in the visitor's language: Liquid prints it from snippets/shamtam-sr-i18n into [data-sr-i18n].
    let T = {};
    try { T = JSON.parse(root.querySelector('[data-sr-i18n]').textContent); } catch (_) {}
    const esc = value => String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const t = (key, vars = {}) => Object.entries(vars).reduce((text, [name, value]) => text.split(`[[${name}]]`).join(value), T[key] || '');
    // The live chat is Shopify Inbox; Tidio was removed and these buttons did nothing (audit 2026-09-25 SS-02).
    // <shopify-chat> opens with show() (`open` is only a state flag). No widget → the contact page.
    const openChat = () => {
      const inbox = document.querySelector('shopify-chat');
      if (inbox && typeof inbox.show === 'function') { inbox.show(); return; }
      window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/contact';
    };
    const countryName = () => country.options[country.selectedIndex]?.text || t('ship_your_country');
    const flagFor = code => [...code.toUpperCase()].map(letter => String.fromCodePoint(127397 + letter.charCodeAt(0))).join('');
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, maximumFractionDigits: 2 }).format(Number(amount));
    const renderGuide = () => {
      const rule = thresholds[country.value];
      const excluded = country.value === 'CH' || country.value === 'NO';
      countryFlag.textContent = flagFor(country.value);
      dutyNote.classList.toggle('sh-note--warning', excluded);
      dutyNote.classList.toggle('sh-note--included', !excluded);
      if (excluded) {
        dutyTitle.textContent = t('ship_duty_ex_title');
        dutyCopy.textContent = t('ship_duty_ex_copy', { country: countryName() });
      } else {
        dutyTitle.textContent = t('ship_duty_in_title');
        dutyCopy.textContent = t('ship_duty_in_copy', { country: countryName() });
      }
      if (!rule) {
        summary.innerHTML = '<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>' + t('ship_choose') + '</p>';
        return;
      }
      summary.innerHTML = `<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>${t('ship_free_from', { amount: esc(money(rule.minimum, rule.currency)), country: esc(countryName()) })}</p>`;
    };
    const requestRates = async () => {
      ratesBox.hidden = true;
      ratesBox.replaceChildren();
      button.disabled = true;
      button.textContent = t('ship_checking');
      summary.innerHTML = '<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>' + t('ship_checking_live') + '</p>';
      try {
        const cart = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null);
        if (!cart || !cart.item_count) throw new Error('empty-cart');
        const address = { country: country.value };
        if (postcode.value.trim()) address.zip = postcode.value.trim();
        const prepared = await fetch(root.dataset.prepareUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ shipping_address: address }) });
        if (!prepared.ok && prepared.status !== 202) throw new Error('prepare-failed');
        let result;
        for (let attempt = 0; attempt < 12; attempt += 1) {
          await new Promise(resolve => setTimeout(resolve, 450));
          result = await fetch(root.dataset.asyncUrl, { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null);
          if (result?.shipping_rates) break;
        }
        if (!result?.shipping_rates) throw new Error('pending');
        if (!result.shipping_rates.length) throw new Error('no-rates');
        const freeRates = result.shipping_rates.filter(rate => Number(rate.price) === 0);
        const visibleRates = freeRates.length ? freeRates : result.shipping_rates;
        summary.innerHTML = '<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>' + t(freeRates.length ? 'ship_free_ok' : 'ship_choices') + '</p>';
        visibleRates.forEach(rate => {
          const row = document.createElement('div'); row.className = 'sh-rate-card__rate';
          const name = document.createElement('span'); name.className = 'sh-rate-card__rate-name'; name.textContent = rate.name;
          const price = document.createElement('span'); price.className = 'sh-rate-card__rate-price'; price.textContent = Number(rate.price) === 0 ? t('ship_free') : money(rate.price, rate.currency || thresholds[country.value]?.currency || cart.currency);
          row.append(name, price); ratesBox.append(row);
        });
        ratesBox.hidden = false;
      } catch (error) {
        const message = t(error.message === 'empty-cart' ? 'ship_err_empty' : error.message === 'no-rates' ? 'ship_err_norates' : 'ship_err_load');
        summary.innerHTML = `<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>${message}</p>`;
      } finally { button.disabled = false; button.textContent = t('ship_check'); }
    };
    country.addEventListener('change', () => {
      if (marketForm) marketForm.requestSubmit();
    });
    button.addEventListener('click', requestRates);
    root.querySelectorAll('[data-sh-open-chat]').forEach(chatButton => chatButton.addEventListener('click', openChat));
    postcode.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); requestRates(); } });
    renderGuide();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shamtam-shipping-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-shipping-journey]');
    if (!root) return;
    const dataNode = root.querySelector('[data-shipping-thresholds]');
    let thresholds = {};
    try { thresholds = JSON.parse(dataNode.textContent); } catch (_) { return; }
    const country = root.querySelector('[data-country]');
    const postcode = root.querySelector('[data-postcode]');
    const button = root.querySelector('[data-calculate]');
    const summary = root.querySelector('[data-threshold-summary]');
    const ratesBox = root.querySelector('[data-rates]');
    const countryFlag = root.querySelector('[data-country-flag]');
    const dutyNote = root.querySelector('[data-duty-note]');
    const dutyTitle = root.querySelector('[data-duty-title]');
    const dutyCopy = root.querySelector('[data-duty-copy]');
    // The live chat is Shopify Inbox; Tidio was removed and these buttons did nothing (audit 2026-09-25 SS-02).
    // <shopify-chat> opens with show() (`open` is only a state flag). No widget → the contact page.
    const openChat = () => {
      const inbox = document.querySelector('shopify-chat');
      if (inbox && typeof inbox.show === 'function') { inbox.show(); return; }
      window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'pages/contact';
    };
    const countryName = () => country.options[country.selectedIndex]?.text || 'your country';
    const flagFor = code => [...code.toUpperCase()].map(letter => String.fromCodePoint(127397 + letter.charCodeAt(0))).join('');
    const money = (amount, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, maximumFractionDigits: 2 }).format(Number(amount));
    const renderGuide = () => {
      const rule = thresholds[country.value];
      const excluded = country.value === 'CH' || country.value === 'NO';
      countryFlag.textContent = flagFor(country.value);
      dutyNote.classList.toggle('sh-note--warning', excluded);
      dutyNote.classList.toggle('sh-note--included', !excluded);
      if (excluded) {
        dutyTitle.textContent = 'Import charges may apply on delivery';
        dutyCopy.textContent = `For ${countryName()}, local import charges may be collected by customs or the carrier.`;
      } else {
        dutyTitle.textContent = 'Included in your checkout total';
        dutyCopy.textContent = `For ${countryName()}, taxes and duties are included, so there is no unexpected import bill.`;
      }
      if (!rule) {
        summary.innerHTML = '<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>Choose your country and postcode to see the delivery choices available at checkout.</p>';
        return;
      }
      summary.innerHTML = `<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p><strong>Free delivery from ${money(rule.minimum, rule.currency)}</strong> to ${countryName()}. Add a postcode to see the exact options for your basket.</p>`;
    };
    const requestRates = async () => {
      ratesBox.hidden = true;
      ratesBox.replaceChildren();
      button.disabled = true;
      button.textContent = 'Checking…';
      summary.innerHTML = '<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>Checking the live delivery options for your basket…</p>';
      try {
        const cart = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null);
        if (!cart || !cart.item_count) throw new Error('empty-cart');
        const address = { country: country.value };
        if (postcode.value.trim()) address.zip = postcode.value.trim();
        const prepared = await fetch(root.dataset.prepareUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ shipping_address: address }) });
        if (!prepared.ok && prepared.status !== 202) throw new Error('prepare-failed');
        let result;
        for (let attempt = 0; attempt < 12; attempt += 1) {
          await new Promise(resolve => setTimeout(resolve, 450));
          result = await fetch(root.dataset.asyncUrl, { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null);
          if (result?.shipping_rates) break;
        }
        if (!result?.shipping_rates) throw new Error('pending');
        if (!result.shipping_rates.length) throw new Error('no-rates');
        summary.innerHTML = '<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p><strong>These are the delivery choices available for your current basket.</strong> The selected rate is confirmed at checkout.</p>';
        result.shipping_rates.forEach(rate => {
          const row = document.createElement('div'); row.className = 'sh-rate-card__rate';
          const name = document.createElement('span'); name.className = 'sh-rate-card__rate-name'; name.textContent = rate.name;
          const price = document.createElement('span'); price.className = 'sh-rate-card__rate-price'; price.textContent = Number(rate.price) === 0 ? 'Free' : money(rate.price, rate.currency || thresholds[country.value]?.currency || cart.currency);
          row.append(name, price); ratesBox.append(row);
        });
        ratesBox.hidden = false;
      } catch (error) {
        const message = error.message === 'empty-cart' ? 'Add an item to your bag first, then we’ll show the live delivery choices for it.' : error.message === 'no-rates' ? 'We could not find a delivery option for this basket and postcode. Please try a full postcode or open live chat.' : 'We could not load the live options just now. You can still see all available delivery choices at checkout.';
        summary.innerHTML = `<span class="sh-rate-card__summary-mark" aria-hidden="true">✦</span><p>${message}</p>`;
      } finally { button.disabled = false; button.textContent = 'Check delivery'; }
    };
    country.addEventListener('change', renderGuide);
    button.addEventListener('click', requestRates);
    root.querySelectorAll('[data-sh-open-chat]').forEach(chatButton => chatButton.addEventListener('click', openChat));
    postcode.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); requestRates(); } });
    renderGuide();
  })();

  } catch(e) { console.error(e); }
})();
})();
